import { apiRequest } from './core/client';

/**
 * The domains the server may fetch vendor documents from (plan W3). Public
 * domains are added automatically on first use; Matt blocks or removes them.
 */
export interface FetchDomain {
  domain: string;
  status: 'allowed' | 'blocked';
  source: 'seed' | 'auto' | 'matt';
  firstUrl: string | null;
  orderId: string | null;
  vendor: string | null;
  label: string | null;
  setupFolder: string | null;
  addedAt: string | null;
  lastUsedAt: string | null;
  useCount: number;
  updatedBy: string | null;
}

export async function listFetchDomains(): Promise<FetchDomain[]> {
  const r = await apiRequest<{ domains: FetchDomain[] }>({ path: '/orders/fetch-domains', method: 'GET' });
  return r.domains;
}

export async function setFetchDomainStatus(domain: string, status: FetchDomain['status']): Promise<void> {
  await apiRequest({ path: `/orders/fetch-domains/${encodeURIComponent(domain)}`, method: 'PUT', body: { status } });
}
